module.exports = __webpack_public_path__ + "static/img/IMG_20160822_143644.95e0560f.jpg";